function sendDTMMenuEvent(tabName, itemName) {
    digitalData.menuItem = {
        tabName: tabName,
        itemName: itemName
    };

    DTMTrack('Tab Click');
}

function sendDTMButtonClickEvent(name) {
    digitalData.button = {
        name: name
    };

    DTMTrack('Button Press');
}

function DTMTrack(name) {
    _satellite.track(name);
}
